import { render, staticRenderFns } from "./TermAndCondition.vue?vue&type=template&id=1a658438&scoped=true"
import script from "./TermAndCondition.vue?vue&type=script&setup=true&lang=js"
export * from "./TermAndCondition.vue?vue&type=script&setup=true&lang=js"
import style0 from "./TermAndCondition.vue?vue&type=style&index=0&id=1a658438&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a658438",
  null
  
)

export default component.exports